import React from 'react'

export default function CenterdedStyle({ children }) {
  return <div style={{ textAlign: 'center' }}>{children}</div>
}
